module.exports = __webpack_public_path__ + "img/erweima.fea15d26.png";